














































import {Component, Vue , Prop} from "vue-property-decorator";

@Component({})
export default class ProjectItem extends Vue{
  @Prop({
    type:Object,
    default:()=>{}
  })
  caseInfo: any;

  getCaseInfo(){
    let case_info = this.caseInfo;
    this.$set(case_info, 'num', case_info.num.split('-')[0]);
    this.$set(case_info, 'title', case_info.title.split('-')[0]);
    this.$set(case_info, 'caseReason', case_info.caseReason.split('-')[0]);
  }
  formatDate(timestamp:any) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private onDetail(){

  }

  private onConsult(){

  }
}
